import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConfigService } from "src/app/services/app-config.service";
import { ApiService } from "./api.service";
import { of } from "rxjs";
import { rest } from "lodash";
@Injectable({
  providedIn: "root",
})
export class SurveyService {
  baseUrl: string = this.appConfig.configuration.environment.endPoints.pbisServices; // "https://localhost:44315"
  parentId: string = null;
  parentUsername: string = null;

  constructor(
    private appConfig: AppConfigService,
    private api: ApiService,
    private oauth: OAuthService
  ) {}

  createSurvey(request: any): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys`;
    return this.api
      .post(path, request)
      .pipe(map((response) => response as any));
  }

  createSurveyQuestion(request: any): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/questions`;
    return this.api
      .post(path, request)
      .pipe(map((response) => response as any));
  }

  deleteSurvey(id: any) {
    const path = `${this.baseUrl}/v1/surveys/${id}`;
    return this.api.delete(path).pipe(map((response) => response as any));
  }
  getSurveys(staffId): Observable<any> { 
    const path = `${this.baseUrl}/v1/surveys/list/${staffId}`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  getQuestions() {
    var questions = [];
    questions.push("Question 1");
    questions.push("Question 2");
    questions.push("Question 3");
    questions.push("Question 4");
    questions.push("Question 5");
    questions.push("Question 6");
    questions.push("Question 7");

    return questions;
  }
  getSurveyById(id): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/${id}`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  getSurveyQuestions(): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/questions`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  createResource(request: any, file: File): Observable<any> {
    let path = `${this.baseUrl}/v1/surveys/resources`;
    return this.api
      .postFile(path, request, file)
      .pipe(map((response) => response as any));
  }

  archiveResource(res: any) {
    const path = `${this.baseUrl}/v1/surveys/resources/${res.resourceId}/archive`;
    return this.api.put(path, res).pipe(map((response) => response as any));
  }

  unarchiveResource(res: any) {
    const path = `${this.baseUrl}/v1/surveys/resources/${res.resourceId}/unarchive`;
    return this.api.put(path, res).pipe(map((response) => response as any));
  }



  getSurveyResourcesByStaff(staffId: any) {
    let path = `${this.baseUrl}/v1/staff/${staffId}/surveys/resources`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  saveAnswers(surveyId, studentId, surveyModel): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/${surveyId}/answers/${studentId}`;
    return this.api
      .post(path, surveyModel)
      .pipe(map((response) => response as any));
  }
  getSurveyAnswers(surveyId, studentId): Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/${surveyId}/answers/${studentId}`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  viewResultById(surveyId) {
    const path = `${this.baseUrl}/v1/surveys/${surveyId}/answers`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  getQuestionCategories():Observable<any> {
    const path = `${this.baseUrl}/v1/surveys/questions/categories`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
}

// TODO: We can return all surveyDetails using getSurveys() API but it will be heavy.
